import * as API from "szyx-axios";
import api from "../api/api";
import {
  ApiRequest,
  SuccesBase,
  ErrBase,
  SuccesNotify,
  ErrNotify
} from "../base/baseModel";
export default {
  state: {
    provinceArr: [],
    cityArr: [],
    memberArr: []
  },
  //getters可以认为是store的计算属性
  getters: {
    provinceArr(state) {
      return state.provinceArr;
    },
    cityArr(state) {
      return state.cityArr;
    },
    memberArr(state) {
      return state.memberArr;
    }
  },
  mutations: {
    SET_PROVINCEARR: (state, provinceArr) => {
      state.provinceArr = provinceArr;
    },
    SET_CITYARR: (state, cityArr) => {
      state.cityArr = cityArr;
    },
    SET_MEMBERARR: (state, memberArr) => {
      state.memberArr = memberArr;
    }
  },
  actions: {
    GET_PROVINCEARR({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        api
          .province()
          .then(result => {
            if (!ApiRequest(result)) {
              reject(result);
            }
            commit("SET_PROVINCEARR", result.data);
            // dispatch("GET_CITYARR", '11');
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GET_CITYARR({ commit }, provinceNo) {
      return new Promise((resolve, reject) => {
        api
          .city({ provinceNo: provinceNo })
          .then(result => {
            if (!ApiRequest(result)) {
              reject(result);
            }
            commit("SET_CITYARR", result.data);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GET_MEMBERARR({ commit }, provinceNo) {
      return new Promise((resolve, reject) => {
        api
          .memberList()
          .then(result => {
            if (!ApiRequest(result)) {
              reject(result);
            }
            commit("SET_MEMBERARR", result.data);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/login_store.js